import { BookOutlined, ArrowRightAlt } from "@material-ui/icons";
import React from "react";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { Link } from "react-router-dom";

export const DropdownItem = ({ to, onClick, sem, sup }) => {
  return (
    <li>
      <Link to={to} className="link" onClick={onClick && onClick}>
        <div className="icon">
          <BookOutlined />
        </div>
        <var>
          {sem}
          <sup>{sup}</sup>
        </var>{" "}
        Semester
        <ArrowForwardIosIcon className="arrow-right" />
      </Link>
    </li>
  );
};
